const isValidOrigin = (origin) => {
  return origin.startsWith('file://') || origin.endsWith('.andapp.jp');
};

class ContextIsolationContents {
  static initContents(bridge, infos) {
    let messageId = 0;
    const promiseRegistry = new Map();
    const wrapper = async function(name) {
      const id = ++messageId;
      const key = name;
      const promise = new Promise((resolve, reject) => {
        promiseRegistry.set(`response-${key}-${id}`, { resolve, reject });
      });
      window.postMessage({ key, id, request: [...arguments].slice(1) }, '*');
      return await promise;
    };

    infos.forEach((info) => {
      if (info.isFunction) {
        bridge[info.name] = wrapper.bind(null, info.name);
      } else {
        Object.defineProperty(bridge, info.name, { get: wrapper.bind(null, info.name) });
      }
    });

    window.addEventListener('message', async(e) => {
      if (!isValidOrigin(e.origin)) return;

      const callback = promiseRegistry.get(e.data.key);
      if (callback) {
        const response = e.data.response;
        if (response && response.error) {
          callback.reject(response.error);
        } else {
          callback.resolve(response);
        }
      }
    });
  }

  static replaceEventEmitterListener(emitters) {
    const Callbacks = new Map();

    const addEventEmitterListener = (event, listener, isOnce) => {
      let listeners = [];
      const callback = Callbacks.get(event);
      if (callback) {
        listeners = callback.listeners;
      }
      listeners.push(listener);
      Callbacks.set(event, { isOnce, listeners });
    };

    emitters.forEach((emitter) => {
      Object.assign(emitter, {
        on: (event, listener) => {
          addEventEmitterListener(event, listener, false);
        },
        once: (event, listener) => {
          addEventEmitterListener(event, listener, true);
        }
      });
    });

    window.addEventListener('message', (e) => {
      if (!isValidOrigin(e.origin)) return;

      const key = e.data.event;
      const callback = Callbacks.get(key);
      if (callback) {
        if (callback.isOnce) {
          Callbacks.delete(key);
        }

        callback.listeners.forEach((listener) => {
          listener(...e.data.args);
        });
      }
    });
  }
}

module.exports = ContextIsolationContents;
